import { TariffService } from './tariff';
import { TariffType } from '../../schema';

export async function findOneById (id: number): Promise<TariffType> {
    return TariffService.findOneById(id);
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/services/tariff/tariff.find-one-by-id.ts